var r=function(r,t){if("string"==typeof r||"number"==typeof r)return t(r);if(Array.isArray(r))return r.map(t);var e={};return Object.keys(r).forEach((function(n){return e[n]=t(r[n])})),e};export{r as modifyResponsiveValue};
//# sourceMappingURL=index.js.map
